module.exports = __webpack_public_path__ + "img/namron-logo.24ada424.jpg";